import { type SettingsConfig, SettingsType } from '@ardoq/view-settings';
import { IconName } from '@ardoq/icons';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { ModernizedBlockDiagramViewSettings } from '../types';
import { BLOCK_DIAGRAM_LAYOUT_OPTIONS } from '../consts';
import { getLayoutDirectionOption, separateReferencesDropdown } from '../menus';
import { ViewIds } from '@ardoq/api-types';
import { componentStyleDropdown } from 'tabview/relationshipDiagrams/leftMenuItems';
import { OnViewSettingsUpdate } from '@ardoq/data-model';
import { t, type I18nLocale } from '@ardoq/i18n';

const VIEW_ID = ViewIds.MODERNIZED_BLOCK_DIAGRAM;

type GetModernizedLeftMenuArgs = {
  viewSettings: ModernizedBlockDiagramViewSettings;
  onViewSettingsUpdate: OnViewSettingsUpdate;
  i18nLocale: I18nLocale;
};
const getLeftMenu = ({
  viewSettings,
  onViewSettingsUpdate,
  i18nLocale,
}: GetModernizedLeftMenuArgs): SettingsConfig[] => {
  const layoutDirectionOptions = BLOCK_DIAGRAM_LAYOUT_OPTIONS.map(
    getLayoutDirectionOption(viewSettings, VIEW_ID, i18nLocale)
  );

  return [
    {
      id: 'layoutDirection',
      type: SettingsType.DROPDOWN,
      iconName: IconName.SORT_ASC,
      label: t(
        i18nLocale,
        'appLayout:viewPaneHeader.layoutDirection',
        'Layout direction'
      ),
      options: layoutDirectionOptions,
      dropdownSize: DropdownSize.S,
    },
    separateReferencesDropdown(
      VIEW_ID,
      viewSettings.separateReferences,
      onViewSettingsUpdate,
      i18nLocale
    ),
    componentStyleDropdown(
      VIEW_ID,
      viewSettings,
      onViewSettingsUpdate,
      i18nLocale
    ),
  ];
};
export { getLeftMenu };
